module.exports = __webpack_public_path__ + "static/img/Platinum3.acf7878.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Platinum3.svg
// module id = 5swZ
// module chunks = 35